"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayPhoneVisitBadge = exports.displayVirtualProviderBadge = exports.displayBookOnlineBadge = exports.getVisibility = exports.getProviderAvailabilityDaysFromNow = exports.getVisitType = exports.getProviderContactPhone = exports.isVirtualProvider = exports.getProviderSummaryFields = exports.getProviderBadgeFields = exports.getProviderDisplayName = exports.getSummaryFieldValues = void 0;
const get_1 = __importDefault(require("lodash/get"));
const utils_1 = __importStar(require("./utils"));
const globals_1 = require("./constants/globals");
/**
 * Given a summary with defined fields that correspond with provider data
 * and a corresponding facet config for the primary field, retrieve all summary data
 * from a provider and order it based on facet sorting rules.
 * @param {object} provider An object containing provider data.
 * @param {object[]} facets A list of facet definitions from the customer config.
 * @param {object} summary The definition of what data we want to grab from the provider.
 * @return {object[]} A sorted list of objects representing the requested summary data.
 */
function getSummaryFieldValues(provider, facets, summary) {
    let returnFields = [];
    const fieldKey = summary.field;
    const subfieldKey = summary.subfield;
    const secondarySubfieldKey = summary.secondary_subfield;
    const secondarySubarrayKey = summary.secondary_subarray;
    const summaryIgnoreList = summary.ignore || [];
    let fieldData = (0, get_1.default)(provider, fieldKey, []);
    if (secondarySubfieldKey) {
        const fieldDataMap = {};
        for (const data of fieldData) {
            const primaryKey = (0, get_1.default)(data, subfieldKey);
            fieldDataMap[primaryKey] = fieldDataMap[primaryKey] || [];
            // Nested array
            if (secondarySubarrayKey) {
                const subfieldData = (0, get_1.default)(data, secondarySubarrayKey, []);
                for (const subdata of subfieldData) {
                    const secondarySubData = (0, get_1.default)(subdata, secondarySubfieldKey);
                    if (secondarySubData) {
                        fieldDataMap[primaryKey].push(secondarySubData);
                    }
                }
            }
            // Flat array
            else {
                const subData = (0, get_1.default)(data, secondarySubfieldKey);
                if (subData) {
                    fieldDataMap[primaryKey].push(subData);
                }
            }
        }
        for (const [key, value] of Object.entries(fieldDataMap)) {
            if (key) {
                returnFields.push({
                    primary: key,
                    secondary: value
                });
            }
        }
    }
    else {
        if (subfieldKey) {
            const modifiedFieldData = [];
            for (const data of fieldData) {
                modifiedFieldData.push((0, get_1.default)(data, subfieldKey));
            }
            fieldData = modifiedFieldData;
        }
        else if (!Array.isArray(fieldData)) {
            fieldData = [fieldData];
        }
        for (const data of fieldData) {
            if (data) {
                returnFields.push({
                    primary: data
                });
            }
        }
    }
    returnFields = returnFields.filter((field) => summaryIgnoreList.indexOf(field.primary) === -1);
    returnFields = orderedTerms(returnFields, getFacetConfig(facets, fieldKey), 'primary', false);
    const defaultRenderType = secondarySubfieldKey
        ? globals_1.LIST_RENDER_TYPE.HIERARCHY
        : globals_1.LIST_RENDER_TYPE.FLAT;
    returnFields = returnFields.map((field) => {
        field.render_type = summary.render_type || defaultRenderType;
        field.list_type = secondarySubfieldKey
            ? globals_1.LIST_TYPE.HIERARCHY
            : summary.field_type;
        return field;
    });
    return returnFields;
}
exports.getSummaryFieldValues = getSummaryFieldValues;
/**
 * Given a list of terms, orders them based on either a custom order provided
 * by the facet config, their frequency based on facet config and passed in params,
 * or a default alphanumeric sort.
 * @param {object[]} term A list of objects to be sorted on their <valueKey> property.
 * @param {object} facetConfig A facet definition from the customer config with search rules.
 * @param {string} valueKey The property on a <term> object to sort by.
 * @param {boolean} allowFrequencySort Whether to allow frequency sort logic if facet also allows.
 * @return {object[]} The sorted terms array.
 */
function orderedTerms(terms, facetConfig = {}, valueKey = 'value', allowFrequencySort = true) {
    const { order_by_custom = [] } = facetConfig;
    if (order_by_custom.length) {
        const termMap = {};
        for (const term of terms) {
            termMap[term[valueKey]] = term;
        }
        const allOrderedTerms = [];
        // I hope this is an array
        for (const orderedTerm of facetConfig.order_by_custom) {
            const term = termMap[orderedTerm];
            delete termMap[orderedTerm];
            if (term) {
                allOrderedTerms.push(term);
            }
        }
        return allOrderedTerms.concat(Object.values(termMap));
    }
    else if (facetConfig.order_by === 'frequency' && allowFrequencySort) {
        return terms.sort((first, second) => {
            return (0, utils_1.default)(first, second, 'count', true);
        });
    }
    else {
        return terms;
    }
}
/**
 * Gets the facet config that corresponds with the field
 * @param {object[]} facets A list of facet definitions from the customer config.
 * @param {string} field The field to find the corresponding facet for.
 * @return {object || null} The corresponding facet or null if not available.
 */
const getFacetConfig = (facets = [], field) => facets.find((facet) => facet.field.startsWith(field));
/**
 * Returns the display name of a provider.
 * @param {object} provider An object containing provider data.
 * @return {string} The providers full name with degrees appended.
 */
function getProviderDisplayName(provider) {
    var _a;
    let degrees = '';
    if (provider.degrees && provider.degrees.length) {
        const degreeNames = provider.degrees.map((degree) => degree.name);
        degrees = ', ' + degreeNames.join(', ');
    }
    return ((_a = provider.name.full_name) !== null && _a !== void 0 ? _a : provider.name.full) + degrees;
}
exports.getProviderDisplayName = getProviderDisplayName;
/**
 * @typedef {object} Badge
 * @property {string} field
 * @property {string} [value]
 * @property {string} [label]
 * @property {'default' | 'info' | 'success' | 'warning' | 'danger'} [color]
 *
 */
/**
 * Gets all customer approved badges and returns the badges that are applicable for the provider.
 * @param {object} provider An object containing provider data.
 * @param {string[] | object[]} badges An array of customer approved badges from the config.
 * @return {Badge[]} A maximum of {MAX_BADGE_FIELDS} badges applicable to the provider.
 */
function getProviderBadgeFields(provider, badges) {
    const providerBadgeFields = badges
        .filter((badge) => {
        if (typeof badge === 'string')
            return (0, get_1.default)(provider, badge);
        const providerValue = (0, get_1.default)(provider, badge.field);
        if (badge.value != null) {
            if (Array.isArray(providerValue)) {
                return providerValue.includes(badge.value);
            }
            const valueOfSameType = (0, utils_1.convertToType)(providerValue, badge.value);
            return providerValue === valueOfSameType;
        }
        return providerValue;
    })
        .slice(0, globals_1.MAX_BADGE_FIELDS);
    return providerBadgeFields;
}
exports.getProviderBadgeFields = getProviderBadgeFields;
/**
 * For every summary data field a provider has, get the corresponding values
 * out of the provider object, and create an array of objects containing those values
 * and the corresponding fieldName key. These objects are used to represent each column
 * in a providers summary.
 * @param {object} provider An object containing provider data.
 * @param {object[]} summaryData An array of summary objects
 * @param {object[]} facets An array of facet data from the customer config.
 * @return {Object[]} An array of summary columns.
 */
function getProviderSummaryFields(provider, summaryData, facets) {
    const providerSummary = [];
    for (const field of summaryData) {
        const values = getSummaryFieldValues(provider, facets, field);
        if (values) {
            let fieldName = field.field;
            if (field.subfield) {
                fieldName += `.${field.subfield}`;
            }
            providerSummary.push({
                field: fieldName,
                values
            });
        }
    }
    return providerSummary;
}
exports.getProviderSummaryFields = getProviderSummaryFields;
function isVirtualProvider(provider, visibility = globals_1.VISIBILITIES.CONSUMER) {
    const visitType = getVisitType(provider, visibility);
    const hasVideoVisit = visitType[globals_1.VISIT_TYPES.VIDEO];
    const isOndemandProvider = provider.provider_type === globals_1.PROVIDER_TYPES.VIRTUAL_CARE;
    return hasVideoVisit || isOndemandProvider;
}
exports.isVirtualProvider = isVirtualProvider;
/**
 * Returns the first phone number for the provider from their contacts
 * @param {object} provider An object containing provider data.
 * @return {string | undefined} The phone number for the provider
 */
function getProviderContactPhone(provider) {
    const phoneContact = provider.contacts.find((contact) => {
        return contact.contact_type === 'phone';
    });
    if (phoneContact) {
        return phoneContact.value;
    }
    return undefined;
}
exports.getProviderContactPhone = getProviderContactPhone;
/**
 * Method to determine what visit types are available on a provider
 * Only cares about the first ehr_data in an appointment.
 * Only cares about video and phone types and breaks early when those are found;
 * other visit types are returned only as a side effect.
 * @param {object} provider An object describing a provider.
 * @param {object} visibility A string defining the visit visibility type (consumer/agent)
 * @return {object} An object with visit_methods as keys set to true values if encountered.
 */
function getVisitType(provider, visibility = globals_1.VISIBILITIES.CONSUMER) {
    const visitType = {};
    // Short-circuit if no appointment_ehr_purposes (like "provider_type":"Virtual Care"; see KENG-13699)
    if (provider.appointment_ehr_purposes) {
        for (const appointment of provider.appointment_ehr_purposes) {
            // for agent visibility - don't return hidden visit types
            const isVisible = visibility === globals_1.VISIBILITIES.CONSUMER ||
                appointment.ehr_data[0].visibilities[visibility] ===
                    globals_1.PURPOSE_USE_TYPE.DIRECT_BOOK;
            if (isVisible) {
                visitType[appointment.ehr_data[0].visit_method] = true;
                // Terminate early if we got the fields we care about
                if (visitType[globals_1.VISIT_TYPES.VIDEO] && visitType[globals_1.VISIT_TYPES.PHONE]) {
                    break;
                }
            }
        }
    }
    return visitType;
}
exports.getVisitType = getVisitType;
/**
 * Returns the number of days from now to the next available appointment date
 * @param {ProviderAvailability} availability
 * @returns {number | undefined}
 */
function getProviderAvailabilityDaysFromNow(availability) {
    var _a;
    const soonestAppointmentDate = (_a = availability === null || availability === void 0 ? void 0 : availability.meta) === null || _a === void 0 ? void 0 : _a.min_date_available;
    if (soonestAppointmentDate == null)
        return;
    const daysFromNowMs = new Date(soonestAppointmentDate).valueOf() - new Date().valueOf();
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.ceil(daysFromNowMs / msPerDay) || 0;
}
exports.getProviderAvailabilityDaysFromNow = getProviderAvailabilityDaysFromNow;
/**
 * Determine if the visibility is agent
 * @param {*} config
 * @returns {string} consumer | agent
 */
const getVisibility = function (config) {
    const activeModules = (0, get_1.default)(config, 'active_modules', []);
    const visibilityAgentEnabled = (0, get_1.default)(config, 'active_modules.visibility_agent.enabled', false);
    if ((Array.isArray(activeModules) &&
        (activeModules === null || activeModules === void 0 ? void 0 : activeModules.includes('visibility_agent'))) ||
        visibilityAgentEnabled) {
        return globals_1.VISIBILITIES.AGENT;
    }
    return globals_1.VISIBILITIES.CONSUMER;
};
exports.getVisibility = getVisibility;
/**
 * Determine if the book online badge should be enabled for a provider
 * @param {*} config
 * @param {*} provider
 * @returns {boolean}
 */
const displayBookOnlineBadge = (config, provider) => {
    const providerHasBookOnlineUrl = !!(0, get_1.default)(provider, 'book_online_url');
    const showBookOnlineOnlyWithAvailability = (0, get_1.default)(config, 'modal_display.show_book_online_only_with_availability', false);
    const providerHasAvailability = (0, get_1.default)(provider, 'has_provider_availability', false);
    const displayBookOnlineBadge = (0, get_1.default)(config, 'provider_v9.badges.book_online.enabled', true);
    if (showBookOnlineOnlyWithAvailability && !providerHasAvailability)
        return false;
    if (providerHasBookOnlineUrl && displayBookOnlineBadge)
        return true;
    return false;
};
exports.displayBookOnlineBadge = displayBookOnlineBadge;
/**
 * Determine if the virtual provider badge should be enabled for a provider
 * @param {*} config
 * @param {*} provider
 * @returns {boolean}
 */
const displayVirtualProviderBadge = (config, provider) => {
    const visibility = (0, exports.getVisibility)(config);
    const virtualProvider = isVirtualProvider(provider, visibility);
    const displayVirtualProviderBadge = (0, get_1.default)(config, 'provider_v9.badges.virtual_provider.enabled', true);
    return virtualProvider && displayVirtualProviderBadge;
};
exports.displayVirtualProviderBadge = displayVirtualProviderBadge;
/**
 * Determine if the phone visit badge should be enabled for a provider
 * @param {*} config
 * @param {*} provider
 * @returns {boolean}
 */
const displayPhoneVisitBadge = (config, provider) => {
    const visibility = (0, exports.getVisibility)(config);
    const visitType = getVisitType(provider, visibility);
    const providerHasPhoneVisitType = !!visitType[globals_1.VISIT_TYPES.PHONE];
    const displayPhoneVisitBadge = (0, get_1.default)(config, 'provider_v9.badges.phone_visit.enabled', true);
    return displayPhoneVisitBadge && providerHasPhoneVisitType;
};
exports.displayPhoneVisitBadge = displayPhoneVisitBadge;
//# sourceMappingURL=provider.js.map